import { useEffect, useState } from "react";
import { BookOpen, Menu, X } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { id: "books", label: "The Books" },
  { id: "coming-soon", label: "Coming Soon" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-500 ${
        scrolled
          ? "border-[rgba(212,175,55,0.25)] bg-[#16110D]/80 backdrop-blur-xl"
          : "border-transparent bg-[#16110D]/30 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="flex items-center gap-3"
        >
          <BookOpen className="h-5 w-5 text-abbey-gold" strokeWidth={1.5} />
          <span className="font-cinzel text-sm font-semibold tracking-[0.25em] text-abbey-gold md:text-base">
            FRJOHNBOOK.SHOP
          </span>
        </button>

        <nav className="hidden items-center gap-10 md:flex" data-testid="nav-links-desktop">
          {LINKS.map((link) => (
            <button
              key={link.id}
              data-testid={`nav-link-${link.id}`}
              onClick={() => go(link.id)}
              className="group relative font-cinzel text-[11px] tracking-[0.3em] text-abbey-cream/80 transition-colors duration-300 hover:text-abbey-gold"
            >
              {link.label.toUpperCase()}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-abbey-gold transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-menu-toggle"
          className="text-abbey-gold md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-links-mobile"
          className="border-t border-[rgba(212,175,55,0.2)] bg-[#16110D]/95 px-6 py-6 backdrop-blur-xl md:hidden"
        >
          <div className="flex flex-col gap-5">
            {LINKS.map((link) => (
              <button
                key={link.id}
                data-testid={`nav-link-mobile-${link.id}`}
                onClick={() => go(link.id)}
                className="text-left font-cinzel text-xs tracking-[0.3em] text-abbey-cream/80 transition-colors duration-300 hover:text-abbey-gold"
              >
                {link.label.toUpperCase()}
              </button>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
